import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output
       } from '@angular/core';
import { IconName, Icons } from 'core/icons';
import { FontInjectorService
       } from '../../collage-designer/font-injector.service';
import { Text, TextEffects } from '../../text/text.model';

export interface FontVariant
{
  bold: boolean;
  italic: boolean;
}

@Component({
    selector: 'text-effects-chooser',
    templateUrl: './text-effects-chooser.component.html',
    styleUrls: ['./text-effects-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextEffectsChooserComponent
{
  @Input('textModel') public textModel: Text | undefined = undefined;

  @Output() public effectChange: EventEmitter<TextEffects> =
    new EventEmitter();
  @Output() public fontVariantChange: EventEmitter<FontVariant> =
    new EventEmitter();

  public Object: any = Object;

  public constructor(
      private fontInjectorService: FontInjectorService)
  {}

  public isBoldAvailable(): boolean
  {
    const variants =
        this.fontInjectorService.getFontVariants(this.textModel.fontName);
    return variants.some(f => f.bold && !f.italic);
  }

  public isItalicAvailable(): boolean
  {
    const variants =
        this.fontInjectorService.getFontVariants(this.textModel.fontName);
    return variants.some(f => f.italic && !f.bold);
  }

  private isBoldItalicAvailable(): boolean
  {
    const variants =
        this.fontInjectorService.getFontVariants(this.textModel.fontName);
    return variants.some(f => f.italic && f.bold);
  }

  public toggleEffect(effect: string): void
  {
    this.effectChange.emit({
        ...this.textModel.effects,
        [effect]: !this.textModel.effects[effect]
    });
  }

  public toggleFontVariant(variant: keyof FontVariant): void
  {
    const current: FontVariant = {
      bold: !!this.textModel.fontBold,
      italic: !!this.textModel.fontItalic
    };

    const updated: FontVariant = {...current, [variant]: !current[variant]};
    if (Object.values(updated).every(Boolean) &&
        !this.isBoldItalicAvailable()) {
      if (variant === 'bold') {
        updated.italic = false;
      }
      else {
        updated.bold = false;
      }
    }
    this.fontVariantChange.emit(updated);
  }

  public previewUrl(effect: string): string
  {
    return Icons.url(`effect-${effect}` as IconName);
  }
}
